import { render, staticRenderFns } from "./GetQuote.vue?vue&type=template&id=70fe6d5e&scoped=true&"
import script from "./GetQuote.vue?vue&type=script&lang=js&"
export * from "./GetQuote.vue?vue&type=script&lang=js&"
import style0 from "./GetQuote.vue?vue&type=style&index=0&id=70fe6d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe6d5e",
  null
  
)

export default component.exports